import ForgotPasswordBackOffice from './forgot-password';

export default ForgotPasswordBackOffice;
